var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rotaRestrita
    ? _c(
        "v-app",
        { staticClass: "rota-restrita rounded" },
        [_vm._t("default")],
        2
      )
    : _c(
        "div",
        {
          directives: [
            {
              name: "scroll",
              rawName: "v-scroll",
              value: _vm.onScroll,
              expression: "onScroll"
            }
          ],
          staticClass: "rounded",
          class: {
            "aawz-dock-collapsed": _vm.dockCollapsed,
            "nav-v2": _vm.navUsaV2,
            "has-cc-guide": _vm.ccGuideOpen,
            "has-ff-ia-panel": _vm.ffIaSqueezeAtivo,
            "has-consultor-panel": _vm.consultorSqueezeAtivo,
            "em-rota-imersiva": _vm.rotaImersiva
          },
          style: { "--ia-painel-top-offset": _vm.iaPainelTopOffset }
        },
        [
          _vm.navUsaV2
            ? _c(
                "NavegacaoV2Shell",
                {
                  attrs: {
                    "content-padding-right": _vm.contentPaddingRightV2,
                    "sem-sidebar": _vm.rotaImersiva
                  }
                },
                [_vm._t("default")],
                2
              )
            : _c("NavBar", [_vm._t("default")], 2),
          _c("SimuladorDetalhes"),
          _c("ConversaoRating"),
          _c("Snackbar"),
          _c("BigSnackbar"),
          _c("Modal"),
          _c("SnackModal"),
          _c("TheNewVersionModal"),
          _c("ModalVideos"),
          _c("ModalReleaseNotes"),
          _c("ModalReleaseNotesClient"),
          _c("SendComponent"),
          _c("ModalQrcodeConexao"),
          _c("ModalTermosAtendimento"),
          _c("TriggerSuggesterModal"),
          _c("GlobalModals"),
          _vm.jornadaVisivel ? _c("CentralConfigGuideDrawer") : _vm._e(),
          _vm.jornadaVisivel ? _c("CentralConfigTourGuiado") : _vm._e(),
          _vm.feeFixoIaVisivel ? _c("FeeFixoIaEspecialista") : _vm._e(),
          _vm.consultorPainelVisivel ? _c("ConsultorPainel") : _vm._e(),
          _c(
            "div",
            {
              staticClass: "aawz-floating-dock v-application",
              attrs: { id: _vm.FLOATING_DOCK_ID }
            },
            [_c("AtendimentoPopup"), _c("ChatIaPopUp")],
            1
          ),
          _c(
            "div",
            {
              staticClass: "v-application",
              staticStyle: {
                "z-index": "7",
                "align-items": "flex-end",
                display: "flex",
                "flex-direction": "row",
                position: "fixed",
                bottom: "16px",
                right: "16px"
              }
            },
            [
              !_vm.usuarioAtual.IS_CLIENTE &&
              !_vm.paginaAtual.includes("simulador")
                ? _c("v-fab-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.loadingSimulacoes > 0 &&
                              _vm.show_simulacoes_running,
                            expression:
                              "loadingSimulacoes > 0 && show_simulacoes_running"
                          }
                        ],
                        staticClass: "dont-show-print",
                        style: {
                          "z-index": 3
                        }
                      },
                      [
                        _c(
                          "v-expansion-panels",
                          { attrs: { dark: "" } },
                          [
                            _c(
                              "v-expansion-panel",
                              { on: { click: _vm.expandedPanel } },
                              [
                                _c(
                                  "v-expansion-panel-header",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "actions",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "text-white",
                                                  attrs: { color: "white" }
                                                },
                                                [_vm._v(" mdi-plus ")]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      316907681
                                    )
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        style: {
                                          "margin-right": "10px"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-auto d-flex flex-inline"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "absolute",
                                                  top: "0",
                                                  right: "0"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      small: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.show_simulacoes_running = false
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [
                                                        _vm._v(
                                                          " mdi-close-circle "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "h2",
                                              {
                                                staticClass:
                                                  "list-cards__card__header__title",
                                                style: {
                                                  color: "white",
                                                  "margin-bottom":
                                                    "0px !important",
                                                  "font-size": _vm.expandPanel
                                                    ? "20px"
                                                    : ""
                                                }
                                              },
                                              [_vm._v(" Simulações ")]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "list-cards__card__header__resume v-applicaiton",
                                            staticStyle: {
                                              "margin-left": "10px"
                                            }
                                          },
                                          [
                                            _c("v-progress-circular", {
                                              attrs: {
                                                indeterminate: "",
                                                color: "white",
                                                size: "10",
                                                width: "1"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-expansion-panel-content",
                                  { staticClass: "v-application--is-ltr" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-row",
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                          "justify-content": "space-between"
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "10px",
                                                color: "white"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.loadingSimulacoes === 1
                                                      ? _vm.loadingSimulacoes +
                                                          " simulação"
                                                      : _vm.loadingSimulacoes +
                                                          " simulações"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                cursor: "pointer",
                                                color: "white"
                                              },
                                              on: { click: _vm.seeDetails }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "text-decoration":
                                                      "underline",
                                                    color: "white"
                                                  }
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Ver detalhes")
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.usuarioAtual.IS_CLIENTE
                ? _c("v-fab-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.atualizando,
                            expression: "atualizando"
                          }
                        ],
                        staticClass: "dont-show-print",
                        style: {
                          "z-index": 3
                        }
                      },
                      [
                        _c(
                          "v-expansion-panels",
                          {
                            attrs: { dark: "" },
                            model: {
                              value: _vm.panel,
                              callback: function($$v) {
                                _vm.panel = $$v
                              },
                              expression: "panel"
                            }
                          },
                          [
                            _c(
                              "v-expansion-panel",
                              { on: { click: _vm.expandedPanel } },
                              [
                                _c(
                                  "v-expansion-panel-header",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "actions",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "text-white",
                                                  attrs: { color: "white" }
                                                },
                                                [_vm._v(" mdi-plus ")]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      316907681
                                    )
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        style: {
                                          "margin-right": "10px"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-auto d-flex flex-inline"
                                          },
                                          [
                                            _c(
                                              "h2",
                                              {
                                                staticClass:
                                                  "list-cards__card__header__title",
                                                style: {
                                                  color: "white",
                                                  "margin-bottom":
                                                    "0px !important",
                                                  "font-size": !_vm.expandPanel
                                                    ? "20px"
                                                    : ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.expandPanel
                                                        ? "CI"
                                                        : "Atualizando Contas"
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "list-cards__card__header__resume v-applicaiton",
                                            staticStyle: {
                                              "margin-left": "10px"
                                            }
                                          },
                                          [
                                            _c("v-progress-circular", {
                                              attrs: {
                                                indeterminate: "",
                                                color: "white",
                                                size: "10",
                                                width: "1"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-expansion-panel-content",
                                  { staticClass: "v-application--is-ltr" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-row",
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                          "justify-content": "space-between"
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "10px",
                                                color: "white"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.accounts.length === 1
                                                    ? "" + _vm.accounts[0].nome
                                                    : _vm.accounts.length +
                                                        " instituições"
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                cursor: "pointer",
                                                color: "white"
                                              },
                                              on: { click: _vm.toAccounts }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "text-decoration":
                                                      "underline",
                                                    color: "white"
                                                  }
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v("ver detalhes")
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              !(_vm.$route.name || "").includes("workspace") &&
              !_vm.$currentUser().IS_CLIENTE &&
              false
                ? _c("ChatPopup", { staticClass: "ml-3" })
                : _vm._e(),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.toTop,
                      expression: "toTop"
                    }
                  ],
                  staticClass: "dont-show-print ml-3",
                  attrs: { dark: "", fab: "" },
                  on: { click: _vm.goTop }
                },
                [_c("v-icon", [_vm._v("mdi-chevron-up")])],
                1
              )
            ],
            1
          ),
          _c("ReleaseAnnouncement"),
          _vm.hasDockWidgets
            ? _c("FloatingDockToggle", {
                attrs: { collapsed: _vm.dockCollapsed },
                on: { toggle: _vm.toggleDock }
              })
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }